export const EMOJI_UPLOAD_TYPES = {
  emoji: 1, // emoji 小表情
  sticker: 2, // 贴纸 大表情
}
export const CUSTOM_EMOJI_TYPE = 'custom'
export const ROOM_NAME_AVATAR_PREFIX = 'custom'